<template>
  <v-card elevation="2" class="mx-auto ma-5">
    <v-row align="center" justify="center" class="px-3" style="min-height: 175px">
      <v-col cols="1">
        <v-checkbox v-model="isSelected"></v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-img
            :src="notice.images.medium"
            :lazy-src="notice.images.lazy"
            max-width="150" max-height="150" v-if="notice.images && notice.images.medium">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="red"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col cols="6">
        <h4 v-if="notice.titles.title">{{ notice.titles.title }}</h4>
        <h4 v-else>{{ notice.title }}</h4>
        <h5 v-if="notice.titles.subTitle">{{ notice.titles.subTitle }}</h5>
        <h6 v-if="notice.titles.text">{{ notice.titles.text }}</h6>
        <template v-for="collection in notice.noticeCollections">
          <v-chip :key="getCollectionCode(collection)" small class="ma-1">{{ getCollectionName(collection) }}</v-chip>
        </template>
        <v-btn
            color="red lighten-2"
            dark
            @click="dialogCollections = true"
            small
        >
          {{ Translator('admin.notice_collection.facets.add_to_collection') }}
        </v-btn>
        <v-dialog v-model="dialogCollections" width="500">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ Translator('admin.notice_collection.facets.add_to_collection') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-select
                        v-model="notice.noticeCollections"
                        :items="availableCollections"
                        label="Collections"
                        multiple
                        chips
                        persistent-hint
                        item-text="name"
                        item-value="code"
                        return-object
                        @change="saveCollections"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="1" md="2">
        <v-switch
            v-model="notice.isEnabled"
            @change="switchEnable"
            :label="Translator('admin.notice_collection.facets.activate')"
        ></v-switch>
        <v-btn icon :href="notice.url" target="_blank">
          <v-icon dark>mdi-link</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
// import axios from 'axios'

import axios from 'axios'
import NoticeCollectionAPI from '@/api/noticeCollections'

export default {
  name: 'AdminNoticeItem',
  props: [
    'notice',
  ],
  data () {
    return {
      dialogCollections: false,
      availableCollections: [],
      search: null
    }
  },
  watch: {
    dialogCollections (visible) {
      if (visible) {
        NoticeCollectionAPI.findAll().then(response => {
          this.availableCollections = response.data['hydra:member']
        })
      }
    }
  },
  computed: {
    isSelected: {
      get () {
        return this.$store.state.selectedNotices.includes(this.notice.id)
      },
      set (value) {
        if(value){
          this.$store.commit('selectNotice', this.notice.id)
        }
        else{
          this.$store.commit('unselectNotice', this.notice.id)
        }
      }
    }
  },
  methods: {
    getCollectionName(collection) {
      const code =  (typeof collection !== 'string')
        ? collection.code
        : collection

      const noticeCollection = this.$store.state.noticeCollections.find(o => o.code === code)
      if(noticeCollection){
        return noticeCollection.name;
      }

      return "unknown"
    },
    getCollectionCode(collection) {
      return (typeof collection !== 'string')
          ? collection.code
          : collection
    },
    saveCollections() {
      axios
          .patch('/api/v2/notices/' + this.notice.id, {
                noticeCollections: this.notice.noticeCollections.map(function (o) {return (o.code !== undefined) ? o.code : o;})
              },
              {headers: {'Content-Type': 'application/merge-patch+json'}})
    },
    switchEnable () {
      axios
          .patch('/api/v2/notices/' + this.notice.id, {
                isEnabled: this.notice.isEnabled
              },
              {headers: {'Content-Type': 'application/merge-patch+json'}})
    },
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
